/*
 * Your personal butler.
 *
 * NOTE: May need to call forceUpdate when everything is ready or done.
 *
 * @author Lemuel Raganas <lemuel.raganas@mediacorp.com.sg>
 **/

import ProducerDelegateHandler from "@/libs/common/delegate/ProducerDelegateHandler";
import DefaultProducerDelegateHandler from "@/libs/common/delegate/DefaultProducerDelegateHandler";
import DelegateHandler from "@/libs/common/delegate/DelegateHandler";
import DefaultDelegateHandler from "@/libs/common/delegate/DefaultDelegateHandler";
import Delegate from "@/libs/common/delegate/Delegate";
import ProducerDelegate from "@/libs/common/delegate/ProducerDelegate";
import Deferrable from "@/libs/common/delegate/Deferrable";

export default class Defer {
  public interval: number = 1000;
  public onProceedHandler: ProducerDelegateHandler =
    new DefaultProducerDelegateHandler();
  public onDoneHandler: DelegateHandler = new DefaultDelegateHandler();
  public onNextRunHandler: DelegateHandler = new DefaultDelegateHandler();
  public deferable: Deferrable;

  constructor(options?: {
    interval?: number;
    onNextRun?: Delegate;
    onDone?: Delegate;
    proceed?: ProducerDelegate;
  }) {
    if (options !== undefined) {
      this.interval = options.interval || 1000;
      this.onNextRunHandler.add(options.onNextRun);
      this.onDoneHandler.add(options.onDone);
      this.onProceedHandler.add(options.proceed);
    }
  }

  public static create(options?: {
    interval?: number;
    onNextRun?: Delegate;
    onDone?: Delegate;
    proceed?: ProducerDelegate;
  }): Defer {
    return new Defer(options);
  }

  setDeferrable(deferrable: Deferrable): Defer {
    this.deferable = deferrable;
    return this;
  }

  setInterval(interval: number): Defer {
    this.interval = interval;
    return this;
  }

  onProceed(delegate: ProducerDelegate): Defer {
    this.onProceedHandler.add(delegate);
    return this;
  }

  onDone(delegate: Delegate): Defer {
    this.onDoneHandler.add(delegate);
    return this;
  }

  onNextRun(delegate: Delegate): Defer {
    this.onNextRunHandler.add(delegate);
    return this;
  }

  proceed() {
    const that = this;
    let proceed = false;

    if (that.deferable !== undefined) {
      proceed = that.deferable.onDefer(that);
    } else {
      proceed = this.onProceedHandler.delegate(that);
    }

    if (proceed === undefined) {
      if (that.deferable !== undefined) {
        that.deferable.onReady(that);
      }
      that.onDoneHandler.delegate(that);
      return;
    }

    if (proceed) {
      that.onNextRunHandler.delegate(that);
      that.wait();
      return;
    }

    if (that.deferable !== undefined) {
      that.deferable.onReady(that);
    }
    that.onDoneHandler.delegate(that);
  }

  wait() {
    const that = this;
    window.setTimeout(function () {
      that.proceed();
    }, this.interval);
  }
}
